module.exports = __webpack_public_path__ + "bf2532df/img/defaultProductImg.220a180f.svg";